import { sanitizeString } from "../reportingTool/reportingUtils";
import { FootageType, ReportEventSchema } from "./schema"
import { z } from 'zod';

const isFile = (value: unknown): value is File => {
  return typeof window !== 'undefined' && value instanceof File;
};

export const convertToFormData = (data: z.infer<typeof ReportEventSchema>, token: string): FormData => {
  const formData = new FormData()
  formData.append('token', token);
  formData.append('email', data.email || '');
  data.evidence.forEach((incident, index) => {
    formData.append(`mediaSource-${index}`, incident.mediaSource);
    formData.append(`eventDate-${index}`, sanitizeString(incident.eventDate));
    formData.append(`incidentType-${index}`, sanitizeString(incident.incidentType));
    if (incident.mediaSource === FootageType.Online) {
      incident.url.forEach((url, locIndex) => {
        formData.append(`url-${index}-${locIndex}`, url);
      });
    } else {
      formData.append(`location-${index}`, sanitizeString(incident.location))
    }
    formData.append(`description-${index}`, sanitizeString(incident.description));
    formData.append(`university-${index}`, sanitizeString(incident.university) || '');
    incident.eventFootage?.forEach((file, fileIndex) => {
      if (isFile(file)) {
        formData.append(`incidentMedia-${index}-${fileIndex}`, file);
      }
    });
  });
  return formData
}